/**
 * Get height of header
 */

const v4GetHeaderHeight = () => {
    const header = document.querySelector('.wp-site-blocks > header');
    const height : number = header ? header.getBoundingClientRect().height : 0;

    let root = document.documentElement;
    root.style.setProperty('--v4--header-height', height + "px");
};

// update on resize + scroll
document.addEventListener('DOMContentLoaded', v4GetHeaderHeight, { passive: true });
window.addEventListener('resize', v4GetHeaderHeight, { passive: true });
window.addEventListener('scroll', v4GetHeaderHeight, { passive: true });

/**
 * Scroll effect for header
 */

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.wp-site-blocks > header');
    const target = header ? header.querySelector(':scope > .has-scroll-effect') : null;
    const threshold = 200;

    if (target) {
        const handleScroll = () => {
            target.classList.toggle('is-scrolled', window.scrollY > threshold);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        handleScroll();
    }
});

/**
 * Animate on scroll observer
 */

document.addEventListener("DOMContentLoaded", () => {
    const targets = document.querySelectorAll('.is-style-section-1, .is-style-section-2');

    // Add initial classes
    targets.forEach(target => target.classList.add('has-reveal-effect'));

    // Observe and change class on scrolling
    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        },
        {
            threshold: 0.2 // 1 = trigger on 100% visibility
        }
    );

    targets.forEach(target => {
        observer.observe(target);

        // Check if element is already visible (above the fold)
        const rect = target.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            target.classList.add('is-visible');
        }
    });
});
